import React from 'react';
import { motion } from 'framer-motion';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

// Import your images (unchanged)
import game1 from '../../assets/Abdullah Zahoor/SS_.06.webp';
import game2 from '../../assets/Abdullah Zahoor/Mini Car  ss 3 (1).webp';
import game3 from '../../assets/Abdullah Zahoor/SS06 (2).webp';
import game4 from '../../assets/Abdullah Zahoor/ss05.webp';
import game5 from '../../assets/Abdullah Zahoor/SS01.webp';
import game6 from '../../assets/Abdullah Zahoor/Gangster  ss 3 ui.webp';
import game7 from '../../assets/Abdullah Zahoor/police ss 2.webp';
import game8 from '../../assets/Abdullah Zahoor/mud jeep 1.webp';
import game9 from '../../assets/Abdullah Zahoor/SS05 (2).webp';
import game10 from '../../assets/Abdullah Zahoor/Gangster  ss 2 ui.webp';
import game11 from '../../assets/Abdullah Zahoor/Rickshaw ss 1.webp';
import game12 from '../../assets/Abdullah Zahoor/ss05.webp';
import game13 from '../../assets/Abdullah Zahoor/SS_.02.webp';
import game14 from '../../assets/Abdullah Zahoor/Mini Car  ss 1.webp';
import game15 from '../../assets/Abdullah Zahoor/Police ss 4.webp';

const gameImages = [
  { id: 13, src: game13, alt: 'City Car Driving Game', link: '#' },
  { id: 14, src: game14, alt: 'Mini Car Game', link: '#' },
  { id: 15, src: game15, alt: 'Police Car Chase Simulator', link: '#' },
  { id: 1, src: game1, alt: 'Open World Car Game', link: '#' },
  { id: 2, src: game2, alt: 'Highway Car Racing Game', link: '#' },
  { id: 3, src: game3, alt: 'Offroad Jeep Game Simulator', link: '#' },
  { id: 4, src: game4, alt: 'Flight Simulator Game', link: '#' },
  { id: 5, src: game5, alt: 'Offroad 4X4 Driving Game', link: '#' },
  { id: 6, src: game6, alt: 'Gangster Of Crime City', link: '#' },
  { id: 7, src: game7, alt: 'Police Pursuit Simulator', link: '#' },
  { id: 8, src: game8, alt: '4X4 Mud Jeep Game', link: '#' },
  { id: 9, src: game9, alt: 'City Euro Cargo Truck Sim', link: '#' },
  { id: 10, src: game10, alt: 'Open World Gangster Game', link: '#' },
  { id: 11, src: game11, alt: 'Auto Rickshaw Driving Game', link: '#' },
  { id: 12, src: game12, alt: 'Airplane Simulation Game', link: '#' },
];

// Duplicate for seamless looping
const duplicatedImages = [...gameImages, ...gameImages];

const GameGallery = () => {
  const row1Items = duplicatedImages;
  const row2Items = duplicatedImages;
  const row3Items = duplicatedImages;

  return (
    <section className="relative w-full bg-gradient-to-br from-white via-gray-50 to-white py-20 overflow-hidden">
      {/* Animated background orbs – red/white theme */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-red-200/40 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-rose-200/40 rounded-full blur-3xl animate-pulse delay-1000" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-red-100/30 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 max-w-full mx-auto px-4">
        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
         <h2 className="text-4xl md:text-5xl font-bold">
  <span className="bg-gradient-to-r from-red-600 via-red-500 to-rose-500 bg-clip-text text-transparent">
    Our Games
  </span>
</h2>
        </motion.div>

        {/* Marquee rows */}
        <div className="space-y-6">
          {/* Row 1 – right to left */}
          <div className="overflow-hidden relative">
            <div className="marquee marquee--right-to-left">
              <div className="marquee__group">
                {row1Items.map((game, idx) => (
                  <a
                    key={`row1-${game.id}-${idx}`}
                    href={game.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block w-64 mx-3 group"
                  >
                    <div className="relative bg-white/60 backdrop-blur-md rounded-xl overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-red-200/40 border border-white/20 hover:border-red-400/60">
                      <div className="p-3">
                        <LazyLoadImage
                          src={game.src}
                          alt={game.alt}
                          effect="blur"
                          className="w-full h-40 object-cover rounded-lg"
                        />
                        <h3 className="text-gray-800 text-sm font-semibold mt-2 text-center truncate group-hover:text-red-600 transition-colors">
                          {game.alt}
                        </h3>
                        <div className="mt-2 text-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                          <span className="inline-block bg-gradient-to-r from-red-500 to-rose-500 text-white text-xs px-4 py-1 rounded-full font-semibold shadow-md hover:shadow-lg transform hover:scale-105 transition-all">
                            Play Now
                          </span>
                        </div>
                      </div>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Row 2 – left to right */}
          <div className="overflow-hidden relative">
            <div className="marquee marquee--left-to-right">
              <div className="marquee__group">
                {row2Items.map((game, idx) => (
                  <a
                    key={`row2-${game.id}-${idx}`}
                    href={game.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block w-64 mx-3 group"
                  >
                    <div className="relative bg-white/60 backdrop-blur-md rounded-xl overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-red-200/40 border border-white/20 hover:border-red-400/60">
                      <div className="p-3">
                        <LazyLoadImage
                          src={game.src}
                          alt={game.alt}
                          effect="blur"
                          className="w-full h-40 object-cover rounded-lg"
                        />
                        <h3 className="text-gray-800 text-sm font-semibold mt-2 text-center truncate group-hover:text-red-600 transition-colors">
                          {game.alt}
                        </h3>
                        <div className="mt-2 text-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                          <span className="inline-block bg-gradient-to-r from-red-500 to-rose-500 text-white text-xs px-4 py-1 rounded-full font-semibold shadow-md hover:shadow-lg transform hover:scale-105 transition-all">
                            Play Now
                          </span>
                        </div>
                      </div>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Row 3 – right to left */}
          <div className="overflow-hidden relative">
            <div className="marquee marquee--right-to-left">
              <div className="marquee__group">
                {row3Items.map((game, idx) => (
                  <a
                    key={`row3-${game.id}-${idx}`}
                    href={game.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block w-64 mx-3 group"
                  >
                    <div className="relative bg-white/60 backdrop-blur-md rounded-xl overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-red-200/40 border border-white/20 hover:border-red-400/60">
                      <div className="p-3">
                        <LazyLoadImage
                          src={game.src}
                          alt={game.alt}
                          effect="blur"
                          className="w-full h-40 object-cover rounded-lg"
                        />
                        <h3 className="text-gray-800 text-sm font-semibold mt-2 text-center truncate group-hover:text-red-600 transition-colors">
                          {game.alt}
                        </h3>
                        <div className="mt-2 text-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                          <span className="inline-block bg-gradient-to-r from-red-500 to-rose-500 text-white text-xs px-4 py-1 rounded-full font-semibold shadow-md hover:shadow-lg transform hover:scale-105 transition-all">
                            Play Now
                          </span>
                        </div>
                      </div>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Custom CSS for marquee */}
      <style jsx>{`
        .marquee {
          position: relative;
          width: 100%;
          overflow-x: hidden;
        }
        .marquee__group {
          display: inline-flex;
          white-space: nowrap;
          will-change: transform;
        }
        .marquee--right-to-left .marquee__group {
          animation: scrollRightToLeft 90s linear infinite;
        }
        .marquee--left-to-right .marquee__group {
          animation: scrollLeftToRight 90s linear infinite;
        }
        @keyframes scrollRightToLeft {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        @keyframes scrollLeftToRight {
          0% {
            transform: translateX(-50%);
          }
          100% {
            transform: translateX(0);
          }
        }
        .marquee:hover .marquee__group {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default GameGallery;